import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  TEACHERS_BULK_UPLOAD_ASSIGN_AND_CONFIRMATION_URL,
  TEACHERS_BULK_UPLOAD_WORK_UPLOAD_AND_QR_URL,
  TEACHERS_HOME_URL
} from 'config/urls';
import {
  ASSIGNMENT_CREATE_MODES,
  ASSIGNMENT_CREATE_STEPS
} from 'constants/assignments';
import { get } from 'lodash';
import { transcriptionsAndSolutionsSendFeedback } from 'sdk';

import {
  PreparingPage,
  ReviewAndConfirm
} from 'pages/Teachers/shared/AssignmentDialog/components';
import { useEdLightTracking } from 'utils/integrations/mixpanel';
import { parseParams, reverse } from 'utils/urls';

import CreateMathForm from './components/CreateMathForm';
import AssignmentDialogContext from 'components/AssignmentDialogContext';

const CreateMath = () => {
  const history = useHistory();
  const [mode, setMode] = useState(ASSIGNMENT_CREATE_MODES.TEMPLATE);
  const [currentStep, setCurrentStep] = useState(
    ASSIGNMENT_CREATE_STEPS.CREATE
  );
  const [trackerId, setTrackerId] = useState(null);

  const location = useLocation();
  const searchParams = parseParams(location.search);
  const bulkUploadId = get(searchParams, 'bulkUploadId');

  const { setIsAssignmentDialogOpened } = useContext(AssignmentDialogContext);

  const { trackEvent } = useEdLightTracking({
    feature: 'assignments',
    view: 'math_create_flow',
    customRouteConstant: TEACHERS_HOME_URL
  });

  const handleCreationSuccess = ({ createdTrackerId }) => {
    setTrackerId(createdTrackerId);

    trackEvent('assignment_created', {
      assignment_id: createdTrackerId,
      assignment_type: mode
    });

    if (
      mode === ASSIGNMENT_CREATE_MODES.TEMPLATE ||
      mode === ASSIGNMENT_CREATE_MODES.COPY
    ) {
      handleReviewComplete(createdTrackerId);
      return;
    }

    setCurrentStep(ASSIGNMENT_CREATE_STEPS.PREPARE);
  };

  const handlePrepareSuccess = () => {
    setCurrentStep(ASSIGNMENT_CREATE_STEPS.REVIEW);
  };

  const handleReviewComplete = async () => {
    if (bulkUploadId) {
      history.push(
        reverse(TEACHERS_BULK_UPLOAD_ASSIGN_AND_CONFIRMATION_URL, {
          bulkUploadId
        })
      );
    } else {
      history.push(reverse(TEACHERS_BULK_UPLOAD_WORK_UPLOAD_AND_QR_URL));
    }

    if (
      mode !== ASSIGNMENT_CREATE_MODES.TEMPLATE &&
      mode !== ASSIGNMENT_CREATE_MODES.COPY
    ) {
      transcriptionsAndSolutionsSendFeedback({ trackerId });
    }

    setIsAssignmentDialogOpened(false);
  };

  return (
    <>
      {currentStep === ASSIGNMENT_CREATE_STEPS.CREATE && (
        <CreateMathForm
          mode={mode}
          setMode={setMode}
          onCreationSuccess={handleCreationSuccess}
        />
      )}

      {currentStep === ASSIGNMENT_CREATE_STEPS.PREPARE && (
        <PreparingPage
          trackerId={trackerId}
          onPrepareSuccess={handlePrepareSuccess}
        />
      )}

      {currentStep === ASSIGNMENT_CREATE_STEPS.REVIEW && trackerId && (
        <ReviewAndConfirm
          trackerId={trackerId}
          onComplete={handleReviewComplete}
          showStepper={false}
        />
      )}
    </>
  );
};

export default CreateMath;
